import { Component } from '@angular/core';

@Component({
  selector: 'app-loss-prevention-admin-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: false,
})
export class LossPreventionAdminDashboardComponent {
  public navItemName: string = 'dashboard';
}
